export default __webpack_public_path__ + "static/media/CarImages.SportagGallery5.d629d3a5.jpg";